import { getSentrySdk } from './registry';

export function trackEvent(name: string, data?: Record<string, unknown>): void {
	const sdk = getSentrySdk();
	if (!sdk) return;
	sdk.captureMessage(name, { level: 'info', extra: data });
}

export function trackError(error: unknown, context?: Record<string, unknown>): void {
	const sdk = getSentrySdk();
	if (!sdk) return;
	const err = error instanceof Error ? error : new Error(
		typeof error === 'string' ? error : (JSON.stringify(error) ?? String(error))
	);
	const extra = context
		? { ...context, ...(!(error instanceof Error) && { originalError: error }) }
		: !(error instanceof Error) ? { originalError: error } : undefined;
	sdk.captureException(err, { extra });
}
